import { httpsCallable } from "firebase/functions";
import { functions } from "shared/api/firebase";
import { CreateGameNameAssistantResponse } from "../type";

export const createGeneralAssistant = async () => {
  try {
    const fn = httpsCallable(functions, "createGeneralTranslationAssistant");
    const { data: responseData } = await fn();
    return responseData as CreateGameNameAssistantResponse;
  } catch (error) {
    console.error("Failed to create general assistant:", error);
    throw error;
  }
};
